import angular from 'angular';
import loansCatalogDetailHeaderComponent from './loansDetailHeader.component';

let loansCatalogDetailHeaderModule = angular.module('loansDetailHeader', [
])

.component('loansDetailHeader', loansCatalogDetailHeaderComponent)

.name;

export default loansCatalogDetailHeaderModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailHeader/loansDetailHeader.js